import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../stores/authStore';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export function RegisterPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { register, loading, error } = useAuth();
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [referralCode, setReferralCode] = useState(params.get('ref') ?? '');

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    try {
      await register({ email, username, password, referralCode: referralCode || undefined });
      navigate('/home');
    } catch { /* shown from store */ }
  }

  return (
    <div className="min-h-screen max-w-md mx-auto flex flex-col px-6 pt-12 pb-10">
      <div className="flex flex-col items-center gap-4 mb-8">
        <img src="/logo.jpg" alt="HMT DAO" className="w-20 h-20 rounded-2xl shadow-glow" />
        <div className="text-center">
          <h1 className="text-xl font-extrabold tracking-[0.25em]">
            <span className="text-accent">HMT</span><span className="text-fg">DAO</span>
          </h1>
          <p className="mt-1 text-xs uppercase tracking-[0.3em] text-fg-muted">Join the Network</p>
        </div>
      </div>

      <form onSubmit={onSubmit} className="space-y-4">
        <Input label="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
        <Input label="Username" value={username} onChange={(e) => setUsername(e.target.value)} minLength={3} maxLength={32} autoComplete="username" required />
        <Input label="Password (min 8)" type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={8} autoComplete="new-password" required />
        <Input
          label="Referral code (optional)"
          value={referralCode}
          onChange={(e) => setReferralCode(e.target.value.toUpperCase())}
          maxLength={32}
          hint={referralCode ? `Joining under code: ${referralCode}` : undefined}
        />
        {error && (
          <div className="p-3 rounded-xl bg-danger/10 border border-danger/30 text-danger text-sm">{error}</div>
        )}
        <Button type="submit" fullWidth size="lg" loading={loading}>Create account</Button>
      </form>

      <p className="mt-8 text-center text-sm text-fg-muted">
        Have an account?{' '}
        <Link to="/login" className="text-accent font-semibold hover:text-accent-hover">Sign in</Link>
      </p>
    </div>
  );
}
